import { PaymentType } from '@egovsolutions/angular-payment-types';

const isCard = (method) => method.cardLastFour !== undefined;
const isEcheck = (method) => method.accountLastFour !== undefined;
const getPaymentType = (method) => {
    if (isCard(method)) {
        if (method.usCard)
            return PaymentType.USCard;
        else
            return PaymentType.NonUSCard;
    }
    else
        return PaymentType.ECheck;
};

/*
 * Public API Surface of angular-payment-methods
 */

/**
 * Generated bundle index. Do not edit.
 */

export { getPaymentType, isCard, isEcheck };

